module.exports = __webpack_public_path__ + "static/media/S (46).44a6cc81.jpg";